import { getKey } from 'owa-search-service';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { getListViewTypeString } from 'owa-mail-list-store';
import getSearchScopeListViewType from './helpers/getSearchScopeListViewType';
export default {
    AddSuggestionPillAction: {
        datapoint: {
            name: 'AddSuggestionPillAction',
            customData: function (kind) { return [kind]; },
        },
    },
    Autosuggestion3S: {
        datapoint: {
            name: 'TnS_Autosuggestion3S',
        },
    },
    RemoveSuggestionPillAction: {
        datapoint: {
            name: 'RemoveSuggestionPillAction',
            customData: function (kind) { return [kind]; },
        },
    },
    RemoveOrSaveSearchAction: {
        datapoint: {
            name: 'TnS_RemoveOrSaveSearchAction',
        },
    },
    SaveSearch: {
        datapoint: {
            name: 'TnS_SaveSearch',
            customData: function (savedQueryCount) { return [savedQueryCount]; },
        },
    },
    RemoveSaveSearch: {
        datapoint: {
            name: 'TnS_RemoveSaveSearch',
            customData: function (clickOrigin) { return [clickOrigin]; },
        },
    },
    ExecuteSaveSearch: {
        datapoint: {
            name: 'TnS_ExecuteSaveSearch',
        },
    },
    ExitSearchDatapoint: {
        datapoint: {
            name: 'TnS_ExitSearch',
            customData: function (actionSource) { return [actionSource]; },
        },
    },
    executeSearchDatapoint: {
        datapoint: {
            name: 'SearchEndToEnd',
            options: { isQos: true, isCore: true },
            customData: function (mailSearchStore, queryString, actionSource, listViewTypeString, searchScopeKind) { return [
                actionSource,
                mailSearchStore.searchText.length,
                mailSearchStore.suggestionPillIds.length,
                mailSearchStore.staticSearchScope.kind == "PrimaryMailbox" /* PrimaryMailbox */
                    ? folderIdToName(mailSearchStore.staticSearchScope.folderId)
                    : mailSearchStore.staticSearchScope.kind == "Group" /* Group */
                        ? null // TODO 112086: Add the key back once we know how to log PII data.
                        : getKey(mailSearchStore.staticSearchScope),
                getListViewTypeString(getSearchScopeListViewType(mailSearchStore.staticSearchScope)),
                mailSearchStore.staticSearchScope.kind,
            ]; },
        },
    },
    searchProcessKeywordSuggestionsDatapoint: {
        datapoint: {
            name: 'TnS_ProcessKeywordSuggestionsTime',
        },
    },
    searchProcessPeopleSuggestionsDatapoint: {
        datapoint: {
            name: 'TnS_ProcessPeopleSuggestionsTime',
        },
    },
};
//# sourceMappingURL=datapoints.js.map